import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Grid, TextField, withStyles, FormControl, InputLabel, Select, MenuItem, Button } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import Service from "../Networking/networkutils";
import Headers from '../ContractorPlanning/Headers';
import { CircleToBlockLoading } from 'react-loadingg';
import { withSnackbar } from 'notistack';
import { DropzoneDialog } from 'material-ui-dropzone';
import firebase from "../Configs/FirebaseConfig";
import MaterialTable from 'material-table';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const classes = (theme) => ({
  root: {
    flexGrow: 1,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.25)
  },
  dateField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(-1),
    padding: theme.spacing(0.25)
  },
  title: {
    padding: theme.spacing(0.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});
const firebaseFolderName = "PlanningP2/";//"Planning_Test/"
class PreConstructionForm extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      Cols: {
        "id": 0, "Work_Order": null, "Pre_Con_Form_Section": 0, "Role": "", "Customer_phone_number": null, "Customer_email": null, "Special_conditions_or_remarks": null, "Meter_position": null, "Road_class_or_type": null, "Is_site_visit_required": null, "Estimated_job_duration": null, "Type_of_licence_required": null, "Type_of_TMP": null, "Any_public_buildings_vicinity": null, "Moratorium_in_place": null, "Underground_ESB_present_on_map": null, "Overhead_ESB_present_on_map": null, "Gas_transmission_lines_present_on_map": null, "Location_of_main_on_gas_maps": null, "Water_main_position": null, "Sewer_position": null, "Telecomm_services": null, "Distance_in_private_ground": null, "Gas_Main_to_building_line": null, "Works_in_carriageway": null, "Works_in_footpath": null, "Works_in_verge": null, "Special_surfaces": null, "Line_painting": null, "Traffic_lights_sensor_pads": null, "Speed_limit": 0, "Road_width": null, "Works_width": null, "Side_Zone": null, "Unobstructed_road_width": null, "Road_type": null, "Cycle_lanes_present": null, "Parking_restrictions": null, "three_minute_count_Time_of_day": null, "Road_A": null, "Road_B": null, "Road_C": null, "Road_D": null, "roads_with_higher_speed_limit_within_100m": null, "Pedestrian_crossings_vicinity": null, "Bus_stops_vicinity": null, "main_location_confirmed_on_site": null, "Is_SWI_required": null, "Road_quality_or_demage": null, "Any_TMP_restrictions": null, "Stop_or_Go_board_required": null, "Adequate_access_or_room_works": null, "Type_of_machine_required": null, "Overhead_lines": null, "Customer_contacted_or_present": null, "meter_location_agreed": null, "Indication_of_underground_structures": null, "Any_third_party_works_vicinity": null, "Any_public_buildings_not_identified_on_maps": null, "Walls_fences_boundaires_affected": null, "Restricted_access": null, "Photos_taken": null, "Road_plates_required": null, "Comments_to_photos": null, "Fitter_Supervisor_required": null, "Approximate_length_downstream_pipework": null, "GNI_Assistance_required": null, "Application_date": null, "Licence_received_date": null, "Valid_from": null, "Licence_reference_no": null, "Special_licence_conditions": null, "Valid_to": null, "Restricted_hours": null, "Is_SWI_required_for_licence_conditions": null, "Was_TMP_designed": null, "License_Type": null, "LA_Contact_Name": null, "LA_contact_phone_number": null, "Red_Flag": null, "Date_for_site_visit": null, "Customer_Name": "", "Activity_description": "", "Appointment_Start": null, "files": [], "Full_Address": null, "Job_Plan": null
      },
      planningData: {
        Work_Order: null, status: 0, reason: null, opening_excavated: null, surface_category: [], reinstating_agent: null, actual_start_date: null, actual_finish_date: null, planning_tool_id: null, id: null, Agent_Name: null, Proposed_connection_date: null, Confirmed_Site_Ready: null, Number: null, Reinstatement_details: null, Permanent_reinstatement_date: null,
      },
      isLoadMainTable: true,
      OpenDeleteDialog: false,
      DeleteRowData: [],
      isLoadTable: false,
      AgentName: null,
      reinstatingAgents: [],
      reinstatingCrews: [],
      surface_category: [],
      planning: parseInt(props.selectedRow.id),
      precon: parseInt(props.selectedRow.pre_con_form),
      sec_e: parseInt(props.selectedRow.pre_con_se),
      surfacecategoryfilter: {}
    }
  }
  insertSurfaceCategoryData = (newData, resolve) => {
    if (this.state.Cols.Work_Order && this.state.planning && this.state.precon && this.state.sec_e) {
      newData.Work_Order = this.state.Cols.Work_Order;
      newData.planning = this.state.planning;
      newData.precon = this.state.precon;
      newData.sec_e = this.state.sec_e;
      if (newData.surface_category) {
        newData.surface_category = parseInt(newData.surface_category.split("id")[1]);
      }
      Service.post('/bb/api/surface/category/', { data: newData })
        .then(res => {
          if (res.data.surface_category) {
            res.data.surface_category = "id" + res.data.surface_category;
          }
          this.setState({ surface_category: [...this.state.surface_category, res.data] });
          this.props.enqueueSnackbar('Data saved successfully!', { variant: 'success' });
          resolve();
        })
        .catch(error => {
          this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
          resolve();
        });
    } else {
      this.props.enqueueSnackbar('Please save the Pre-con Form details first! then produced with Surface Category details.', { variant: 'error' });
      resolve();
    }
  }
  updateSurfaceCategoryData = (newData, oldData, resolve) => {
    newData.Work_Order = this.state.Cols.Work_Order;
    newData.planning = this.state.planning;
    newData.precon = this.state.precon;
    newData.sec_e = this.state.sec_e;
    if (newData.surface_category) {
      newData.surface_category = parseInt(newData.surface_category.split("id")[1]);
    }
    Service.put('/bb/api/surface/category/' + newData.id, { data: newData })
      .then(res => {
        const dataUpdate = [...this.state.surface_category];
        const index = oldData.tableData.id;
        if (newData.surface_category) {
          newData.surface_category = "id" + newData.surface_category;
        }
        dataUpdate[index] = newData;
        this.setState({ surface_category: [...dataUpdate] });
        this.props.enqueueSnackbar('Data updated successfully!', { variant: 'success' });
        resolve();
      })
      .catch(error => {
        this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
        resolve();
      });
  }
  deleteSurfaceCategoryData = (oldData, resolve) => {
    oldData.Work_Order = this.state.Cols.Work_Order;
    oldData.planning = this.state.planning;
    oldData.precon = this.state.precon;
    oldData.sec_e = this.state.sec_e;
    Service.delete('/bb/api/surface/category/' + oldData.id + '/')
      .then(res => {
        const dataDelete = [...this.state.surface_category];
        const index = oldData.tableData.id;
        dataDelete.splice(index, 1);
        this.setState({ surface_category: [...dataDelete] });
        this.props.enqueueSnackbar('Data deleted successfully!', { variant: 'success' });
        resolve();
      })
      .catch(error => {
        this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
        resolve();
      });
  }
  inputChange = (ev, ele) => {
    var data = this.state.Cols;
    var value = null;
    if (ev.target.type === "number") {
      value = (ev.target.value === "") ? null : ev.target.value;
    }
    else {
      value = ev.target.value;
    }
    data[ev.target.name] = value;
    this.setState({ Cols: data });
  };
  componentDidMount() {
    this._isMounted = true;
    this.getData(this.props);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  loader() {
    if (this.state.API1 && this.state.API2 && this.state.API3 && this.state.API4 && this.state.API5 && this.state.API6) {
      this.setState({ isLoadMainTable: false });
    }
  }
  getData(props) {
    if (this._isMounted) {
      const workOrderNo = props.selectedRow.Work_Order;
      if (workOrderNo != null) {
        var preconData = this.state.Cols;
        var lic_ref_no = "";
        var validto = null;
        if (!props.selectedRow.License_Ext_3_Expiry) {
          if (!props.selectedRow.License_Ext_2_Expiry) {
            if (!props.selectedRow.License_Ext_1_Expiry) {
              if (props.selectedRow.License_Expiry_Date) {
                validto = props.selectedRow.License_Expiry_Date;
              }
            } else {
              validto = props.selectedRow.License_Ext_1_Expiry;
            }
          } else {
            validto = props.selectedRow.License_Ext_2_Expiry;
          }
        } else {
          validto = props.selectedRow.License_Ext_3_Expiry;
        }

        if (!props.selectedRow.License_Ext_3_Comment) {
          if (!props.selectedRow.License_Ext_2_Comment) {
            if (!props.selectedRow.License_Ext_1_Comment) {
              if (props.selectedRow.License_Comment) {
                lic_ref_no = props.selectedRow.License_Comment;
              }
            } else {
              lic_ref_no = props.selectedRow.License_Ext_1_Comment;
            }
          } else {
            lic_ref_no = props.selectedRow.License_Ext_2_Comment;
          }
        } else {
          lic_ref_no = props.selectedRow.License_Ext_3_Comment;
        }
        Service.get('/bb/api/precon/?Work_Order=' + workOrderNo).then(res => {
          if (res.data.length === 1) {
            if (res.data.length === 1 && this.props.selectedRow.pre_con_form === null) {
              this.UpdateIdInPlanning(this.props.selectedRow.id, res.data[0].id);
            }
            preconData = res.data[0];
            preconData.Full_Address = props.selectedRow.Full_Address;
            preconData.Appointment_Start = props.selectedRow.Appointment_Start;
            preconData.Job_Plan = Headers.lookupJobPlan[props.selectedRow.Job_Plan];
            preconData.Application_date = props.selectedRow.License_Arrange_Submitted_Date;
            preconData.Valid_from = props.selectedRow.License_Valid_Date;
            preconData.Valid_to = validto;
            preconData.Licence_reference_no = lic_ref_no;
            this.setState({ Cols: preconData, API1: true }, () => { this.loader() });
          }
          else {
            preconData.Full_Address = props.selectedRow.Full_Address;
            preconData.Appointment_Start = props.selectedRow.Appointment_Start;
            preconData.Job_Plan = Headers.lookupJobPlan[props.selectedRow.Job_Plan];
            preconData.Work_Order = props.selectedRow.Work_Order;
            preconData.Application_date = props.selectedRow.License_Arrange_Submitted_Date;
            preconData.Valid_from = props.selectedRow.License_Valid_Date;
            preconData.Valid_to = validto;
            preconData.Licence_reference_no = lic_ref_no;
            this.setState({ Cols: preconData, API1: true }, () => { this.loader() });
          }
        }).catch(error => {
          this.props.enqueueSnackbar('Something went wrong while fetching Pre-Con data!', { variant: 'error' });
          this.setState({ API1: true }, () => { this.loader() });
        });

        //
        const planningData = this.state.planningData;
        Service.get('/bb/api/precon2/se/?Work_Order=' + workOrderNo).then(res => {
          if (res.data.length === 1) {
            if (res.data.length === 1 && this.props.selectedRow.pre_con_se === null) {
              this.UpdatePreConSeIdInPlanning(this.props.selectedRow.id, res.data[0].id);
            }
            this.setState({ planningData: res.data[0], API2: true }, () => { this.loader() });
          } else {
            planningData.Work_Order = props.selectedRow.Work_Order;
            planningData.planning_tool_id = props.selectedRow.planning_tool;
            this.setState({ planningData: planningData, API2: true }, () => { this.loader() });
          }
        }).catch(error => {
          this.props.enqueueSnackbar('Something went wrong while fetching Pre-Con Sec data!', { variant: 'error' });
          this.setState({ API2: true }, () => { this.loader() });
        });
        //
        if (props.selectedRow.cells_by) {
          Service.get('/bb/api/cellsby/' + props.selectedRow.cells_by).then(res => {
            this.setState({ AgentName: res.data.agent, API3: true }, () => { this.loader() });
          }).catch(error => {
            this.props.enqueueSnackbar('Something went wrong while fetching agent name !', { variant: 'error' });
            this.setState({ API3: true }, () => { this.loader() });
          });
        } else {
          this.setState({ API3: true }, () => { this.loader() });
        }
        //Reinstating Agent && Reinstating Crew
        Service.get('/bb/api/reinstating/agent/').then(res => {
          this.setState({ reinstatingAgents: res.data, API4: true }, () => { this.loader() });
        }).catch(error => {
          this.setState({ API4: true }, () => { this.loader() });
          this.props.enqueueSnackbar('Something went wrong while fetching Reinstating Agent !', { variant: 'error' });
        });
        Service.get('/bb/api/reinstating/crew').then(res => {
          var reinstatingCrewsObj = {};
          for (let i = 0; i < res.data.length; i++) {
            reinstatingCrewsObj[[res.data[i].id]] = res.data[i].name;
          }
          this.setState({ reinstatingCrews: reinstatingCrewsObj, API5: true }, () => { this.loader() });
        }).catch(error => {
          this.setState({ API5: true }, () => { this.loader() });
          this.props.enqueueSnackbar('Something went wrong while fetching Reinstating Crew !', { variant: 'error' });
        });
        var surfacecategoryFilter = {};
        var data = Headers.lookupSurfaceCategory;
        var dataByValues = Object.values(data);
        var dataByKeys = Object.keys(data);
        dataByValues.sort().forEach(function (k, i) {
          surfacecategoryFilter["id" + dataByKeys.find(key => data[key] === k)] = k
        });
        // surfacecategoryfilter = surfacecategoryFilter;
        this.setState({ surfacecategoryfilter: surfacecategoryFilter });
        //Surface Category
        Service.get('/bb/api/surface/category/?Work_Order=' + workOrderNo).then(res => {
          (res.data).forEach(element => {
            if (element.surface_category) {
              element.surface_category = "id" + element.surface_category;
            }
          });
          this.setState({ surface_category: res.data, API6: true }, () => { this.loader() });
        }).catch(error => {
          this.props.enqueueSnackbar('Something went wrong while fetching Surface Category !', { variant: 'error' });
          this.setState({ API6: true }, () => { this.loader() });
        });
      }
    }
  }
  SavePlanningStatusData = (e) => {
    var planningData = this.state.planningData;
    var openingExcavated = parseInt(planningData.opening_excavated);
    planningData.opening_excavated = isNaN(openingExcavated) ? 0 : openingExcavated;
    if (planningData.id === null) {
      Service.post('/bb/api/precon2/se/', { data: planningData })
        .then(res => {
          this.setState({ sec_e: res.data.id });
          this.props.selectedRow.pre_con_se = res.data.id;
          planningData.id = res.data.id;
          const id = this.props.selectedRow.id;
          Service.put('/bb/api/planning/' + id, { data: { id: id, pre_con_se: res.data.id } })
            .then(res => {
              // this.props.enqueueSnackbar('Planning tool status data saved successfully!', { variant: 'success' });
            })
            .catch(error => {
              this.props.enqueueSnackbar("Something went wrong while updating Pre-Con Sec Id in the Planning table!", { variant: 'error' });
            });
        })
        .catch(error => {
          this.props.enqueueSnackbar('Something went wrong while saving updating the Section E  details !', { variant: 'error' });
        });
    }
    else {
      Service.put('/bb/api/precon2/se/' + planningData.id, { data: planningData })
        .then(res => {
          // this.props.enqueueSnackbar('Planning tool status data updated successfully!', { variant: 'success' });
        })
        .catch(error => {
          this.props.enqueueSnackbar('Something went wrong while updating the Section E  details !', { variant: 'error' });
        });
    }
  }
  UpdateIdInPlanning = (planningid, preconId) => {
    Service.put('/bb/api/planning/' + planningid, {
      data: { id: planningid, pre_con_form: preconId }
    }).then(res => {
      if (res.data.pre_con_form) {
        this.props.selectedRow.pre_con_form = res.data.pre_con_form;
      }
    }).catch(error => {

    });
  };
  UpdatePreConSeIdInPlanning = (planningid, preconSeId) => {
    Service.put('/bb/api/planning/' + planningid, {
      data: { id: planningid, pre_con_se: preconSeId }
    }).then(res => {
      if (res.data.pre_con_se) {
        this.props.selectedRow.pre_con_se = res.data.pre_con_se;
      }
    }).catch(error => {
    });
  };
  saveData = (e) => {
    var preconData = this.state.Cols;
    if (!this.props.selectedRow.pre_con_form) {
      Service.post('/bb/api/precon/', { data: preconData })
        .then(res => {
          this.setState({ precon: res.data.id });
          preconData.id = res.data.id;
          Service.put('/bb/api/planning/' + this.props.selectedRow.id, {
            data: { id: this.props.selectedRow.id, pre_con_form: res.data.id }
          }).then(res => {
            if (res.data.pre_con_form) {
              this.props.selectedRow.pre_con_form = res.data.pre_con_form;
              this.props.enqueueSnackbar('Data updated successfully!', { variant: 'success' });
            } else {
              this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
            }
          }).catch(error => {
            this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
          });
        })
        .catch(error => {
          this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
        });
    }
    else {
      Service.put('/bb/api/precon/' + preconData.id, { data: preconData })
        .then(res => {
          this.props.enqueueSnackbar('Data updated successfully!', { variant: 'success' });
        })
        .catch(error => {
          this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
        });
    }
    this.SavePlanningStatusData();
  };
  handleOpen = () => {
    this.setState({ OpenDialog: true });
  }
  handleClose() {
    this.setState({ OpenDialog: false });
  }
  handleDownload = (data) => {
    var storageRef = firebase.storage().ref();
    storageRef.child(data.reference).getDownloadURL().then((url) => {
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = (event) => {
        var blob = xhr.response;
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = data.name;
        a.click();
        window.URL.revokeObjectURL(url);
        this.props.enqueueSnackbar('File downloaded', { variant: 'success' });
      };
      xhr.open('GET', url);
      xhr.send();
    }).catch(function (error) {
      this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
    });
  }

  handleView = (data) => {
    this.props.enqueueSnackbar('Opening in New Tab. Please wait!', { variant: 'info' });
    var storageRef = firebase.storage().ref();
    storageRef.child(data.reference).getDownloadURL().then(function (url) {
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function (event) {
        var blob = xhr.response;
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = data.name;
        window.open(a);
        window.URL.revokeObjectURL(url);
      };
      xhr.open('GET', url);
      xhr.send();
    }).catch(function (error) {
      this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
    });
  }
  handleDelete = (data) => {
    var workOrder = this.state.Cols.Work_Order;
    var preconData = this.state.Cols;
    var storageRef = firebase.storage().ref();
    storageRef.child(data.reference).delete().then(() => {
      storageRef.child(firebaseFolderName + workOrder + '/Pre-Con/').listAll().then((res) => {
        var jsonFileData = [];
        res.items.forEach(function (itemRef) {
          jsonFileData.push({ name: itemRef.name, reference: itemRef.fullPath });
        });
        preconData["files"] = jsonFileData;
        Service.put('/bb/api/precon/' + preconData.id, { data: preconData })
          .then(res => {
            this.setState({ Cols: preconData, isLoadTable: false });
            this.props.enqueueSnackbar('File deleted successfully !', { variant: 'success' });
          })
          .catch(error => {
            this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
            this.setState({ isLoadTable: false });
          });
      }).catch(error => {
        this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
        this.setState({ isLoadTable: false });
      });
    }).catch(function (error) {
      this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
      this.setState({ isLoadTable: false });
    });
  }
  handleSave = (files, event) => {
    this.setState({ OpenDialog: false, isLoadTable: true });
    event.preventDefault();
    const promises = [];
    const storageRef = firebase.storage().ref();
    var workOrder = this.state.Cols.Work_Order;
    var preconData = this.state.Cols;
    files.forEach(file => {
      const referenceName = firebaseFolderName + workOrder + '/Pre-Con/' + file.name;
      const metadata = { contentType: file.type };
      var uploadTask = storageRef.child(referenceName).put(file, metadata);
      promises.push(uploadTask);
      uploadTask.on('state_changed',
        (snapshot) => {
          // const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          switch (snapshot.state) {
            case 'paused':
              this.props.enqueueSnackbar('Upload is paused', { variant: 'info' });
              break;
            case 'running':
              // this.props.enqueueSnackbar('Upload is running', { variant: 'info' });
              break;
            case 'canceled':
              this.props.enqueueSnackbar('Upload is canceled', { variant: 'info' });
              break;
            default:
              return null;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              this.props.enqueueSnackbar("User doesn't have permission to access the object", { variant: 'error' });
              break;
            case 'storage/canceled':
              this.props.enqueueSnackbar("User canceled the upload", { variant: 'error' });
              break;
            case 'storage/unknown':
              this.props.enqueueSnackbar("Unknown error occurred", { variant: 'error' });
              break;
            default:
              this.props.enqueueSnackbar("Unknown error occurred", { variant: 'error' });
              break;
          }
        }
      );
    });
    Promise.all(promises).then(() => {
      storageRef.child(firebaseFolderName + workOrder + '/Pre-Con/').listAll().then(files => {
        var jsonFileData = [];
        files.items.forEach(function (itemRef) {
          jsonFileData.push({ name: itemRef.name, reference: itemRef.fullPath });
        });
        preconData["files"] = jsonFileData;
        Service.put('/bb/api/precon/' + preconData.id, { data: preconData })
          .then(res => {
            var data = this.state.Cols;
            data["files"] = jsonFileData;
            this.setState({ Cols: data, isLoadTable: false });
            this.props.enqueueSnackbar('File uploaded successfully !', { variant: 'success' });
          })
          .catch(error => {
            this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
            this.setState({ isLoadTable: false });
          });
      }).catch(error => {
        this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
        this.setState({ isLoadTable: false });
      });
    }).catch(err => {
      this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' });
      this.setState({ isLoadTable: false });
    });
  }
  handleDeleteFile = () => {
    this.setState({ OpenDeleteDialog: false, isLoadTable: true });
    var rowData = this.state.DeleteRowData;
    this.handleDelete(rowData);
  };
  handleCloseDeleteDialog = () => {
    this.setState({ OpenDeleteDialog: false, DeleteRowData: [] });
  };
  handleDialogChange = (ev, ele) => {
    var data = this.state.planningData;
    data[ev.target.name] = ev.target.value;
    this.setState({ planningData: data });

  };
  render() {
    const setDate = (date, name) => {
      var data = this.state.Cols;
      data[name] = date;
      this.setState({ Cols: data });
    };
    const setPlanningtoolDate = (date, name) => {
      var data = this.state.planningData;
      data[name] = date;
      this.setState({ planningData: data });
    }
    const handleactualstartdate = (date) => {
      setPlanningtoolDate(date, "actual_start_date");
    };
    const handleactualfinishdate = (date) => {
      setPlanningtoolDate(date, "actual_finish_date");
    };
    const handleProposedConnectionDate = (date) => {
      setPlanningtoolDate(date, "Proposed_connection_date");
    };
    // const handlePermanentReinstatementDate = (date) => {
    //   setPlanningtoolDate(date, "Permanent_reinstatement_date");
    // };
    const handleSiteVistDate = (date) => {
      setDate(date, "Date_for_site_visit");
    };
    const handleAppointment_StartDate = (date) => {
      setDate(date, "Appointment_Start");
    };
    const handleApplication_dateChange = (date) => {
      setDate(date, "Application_date");
    };
    const handleLicence_received_dateChange = (date) => {
      setDate(date, "Licence_received_date");
    };
    const handleValid_fromChange = (date) => {
      setDate(date, "Valid_from");
    };
    const handleValid_to = (date) => {
      setDate(date, "Valid_to");
    };

    const { classes } = this.props;
    return (

      <div className={classes.root}>
        {(this.state.isLoadMainTable) ?
          (<CircleToBlockLoading color='#005D99' />)
          :
          (
            <div>
              <br />
              <br />
              <Grid container spacing={1}  >
                <Grid item xs={12}>
                  <Button className="alignRight" variant="contained" color="primary" onClick={this.saveData}>Save</Button>
                  <p>  </p>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Card className={classes.root} variant="outlined">
                    <CardContent>
                      <Typography className={classes.title} gutterBottom>
                        Section A - Job Details
                          </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} value={this.state.Cols.Full_Address} InputProps={{ readOnly: true }} name="Full_Address" label="Address" multiline rows={4} variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} value={this.state.Cols.Customer_Name} name="Customer_Name" label="Customer name" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} InputProps={{ readOnly: true }} name="Work_Order" value={this.state.Cols.Work_Order} label="WO number" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Role" value={this.state.Cols.Role} label="Role (owner, builder, etc.)" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Activity_description" value={this.state.Cols.Activity_description} label="Activity description" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Customer_phone_number" value={this.state.Cols.Customer_phone_number} label="Customer phone number" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Job_Plan" value={this.state.Cols.Job_Plan} InputProps={{ readOnly: true }} label="Job code" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} value={this.state.Cols.Customer_email} className={classes.textField} size="small" style={{ width: "100%" }} name="Customer_email" label="Customer email" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker className={classes.dateField} style={{ width: "100%" }} name="Appointment_Start" label="Appointment / target start date" format="dd/MM/yyyy" value={this.state.Cols.Appointment_Start} onChange={handleAppointment_StartDate} KeyboardButtonProps={{ 'aria-label': 'Change date', }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Special_conditions_or_remarks" value={this.state.Cols.Special_conditions_or_remarks} label="Special conditions / remarks" variant="outlined" multiline rows={5} />
                        </Grid>
                        <Grid item xs={6}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <TextField onChange={this.inputChange} className={classes.textField} style={{ width: "100%" }} name="Meter_position" size="small" value={this.state.Cols.Meter_position} label="Meter position" variant="outlined" />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField onChange={this.inputChange} className={classes.textField} style={{ width: "100%" }} name="Road_class_or_type" size="small" value={this.state.Cols.Road_class_or_type} label="Road class / type" variant="outlined" />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card className={classes.root} variant="outlined">
                    <CardContent>
                      <Typography className={classes.title} gutterBottom>
                        Section B - Desktop assessment
                         </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <FormControl size="small" variant="outlined" className={classes.textField} fullWidth>
                            <InputLabel id="label">Is site visit required ?</InputLabel>
                            <Select labelId="label" name="Is_site_visit_required" value={this.state.Cols.Is_site_visit_required} onChange={this.inputChange} label="Is site visit required ?">
                              <MenuItem value={1}>Yes</MenuItem>
                              <MenuItem value={2}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} style={{ width: "100%" }} name="Underground_ESB_present_on_map" value={this.state.Cols.Underground_ESB_present_on_map} label="Underground ESB present on map (LV/MV/HV)" multiline rows={4} variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker className={classes.dateField} style={{ width: "100%" }} id="" name="Date_for_site_visit" label="Date for site visit" format="dd/MM/yyyy" value={this.state.Cols.Date_for_site_visit} onChange={handleSiteVistDate} KeyboardButtonProps={{ 'aria-label': 'Change date', }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl size="small" variant="outlined" fullWidth className={classes.textField}>
                            <InputLabel id="select-label">Overhead ESB present on map (LV/MV/HV)</InputLabel>
                            <Select name="Overhead_ESB_present_on_map" labelId="select-label" value={this.state.Cols.Overhead_ESB_present_on_map} onChange={this.inputChange} label="Overhead ESB present on map (LV/MV/HV)" >
                              <MenuItem value={1}>LV</MenuItem>
                              <MenuItem value={2}>MV</MenuItem>
                              <MenuItem value={3}>HV</MenuItem>
                              <MenuItem value={4}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Estimated_job_duration" value={this.state.Cols.Estimated_job_duration} label="Estimated job duration (hrs)" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl size="small" variant="outlined" fullWidth className={classes.textField}>
                            <InputLabel id="select-label">Gas transmission lines present on map </InputLabel>
                            <Select name="Gas_transmission_lines_present_on_map" labelId="select-label" id="" value={this.state.Cols.Gas_transmission_lines_present_on_map} onChange={this.inputChange} label="Gas transmission lines present on map" >
                              <MenuItem value={1}>Yes</MenuItem>
                              <MenuItem value={2}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Type_of_licence_required" value={this.state.Cols.Type_of_licence_required} label="Type of licence required" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Location_of_main_on_gas_maps" value={this.state.Cols.Location_of_main_on_gas_maps} label="Location of main on gas maps" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Type_of_TMP" value={this.state.Cols.Type_of_TMP} label="Type of TMP (Generic/Site specific)" variant="outlined" />
                          {/* <FormControl size="small" variant="outlined" fullWidth className={classes.textField}>
                            <InputLabel id="select-label">Type of TMP (generic/site specific)?</InputLabel>
                            <Select name="Type_of_TMP" labelId="select-label" value={this.state.Cols.Type_of_TMP} onChange={this.inputChange} label="Type of TMP (generic/site specific)?" >
                              <MenuItem value={1}>Generic</MenuItem>
                              <MenuItem value={2}>Site Specific</MenuItem>
                            </Select>
                          </FormControl> */}
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Water_main_position" value={this.state.Cols.Water_main_position} label="Water main position" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Anypublicbuildingsinvicinity" value={this.state.Anypublicbuildingsinvicinity} label="Any public buildings in vicinity?" variant="outlined" /> */}
                          <FormControl size="small" variant="outlined" fullWidth className={classes.textField}>
                            <InputLabel id="select-label">Any public buildings in vicinity?</InputLabel>
                            <Select name="Any_public_buildings_vicinity" labelId="select-label" id="" value={this.state.Cols.Any_public_buildings_vicinity} onChange={this.inputChange} label="Any public buildings in vicinity?" >
                              <MenuItem value={1}>Yes</MenuItem>
                              <MenuItem value={2}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Sewer_position" value={this.state.Cols.Sewer_position} label="Sewer position" variant="outlined" />
                        </Grid>
                        <Grid item xs={6}>
                          {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Moratoriuminplace" value={this.state.Moratoriuminplace} label="Moratorium in place?" variant="outlined" /> */}
                          <FormControl size="small" variant="outlined" fullWidth className={classes.textField}>
                            <InputLabel id="select-label">Moratorium in place ?</InputLabel>
                            <Select name="Moratorium_in_place" labelId="select-label" id="" value={this.state.Cols.Moratorium_in_place} onChange={this.inputChange} label="Moratorium in place ?" >
                              <MenuItem value={1}>Yes</MenuItem>
                              <MenuItem value={2}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Telecomm_services" value={this.state.Cols.Telecomm_services} label="Telecomm services" variant="outlined" />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Card className={classes.root} variant="outlined">
                    <CardContent>
                      <Typography className={classes.title} gutterBottom>
                        Section C - Site conditions
                        </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <Card className={classes.root}>
                            <CardContent>
                              <Typography className={classes.title} gutterBottom>
                                REINSTATEMENT
                                </Typography>
                              <Grid container spacing={1}>
                                <Grid item xs={12}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Distance_in_private_ground" value={this.state.Cols.Distance_in_private_ground} label="Distance in private ground" variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Gas_Main_to_building_line" value={this.state.Cols.Gas_Main_to_building_line} label="Gas Main to building line" variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField onChange={this.inputChange} className={classes.textField} style={{ width: "100%" }} name="Works_in_carriageway" value={this.state.Cols.Works_in_carriageway} label="Works in carriageway (Identify surface ie HRA, SMA)" variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField onChange={this.inputChange} className={classes.textField} style={{ width: "100%" }} name="Works_in_footpath" value={this.state.Cols.Works_in_footpath} label="Works in footpath (Identify surface ie 10mm, Concrete, slabs)" variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Works_in_verge" value={this.state.Cols.Works_in_verge} label="Works in verge" variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Special_surfaces" value={this.state.Cols.Special_surfaces} label="Special surfaces (ie granite)" variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Line_painting" value={this.state.Cols.Line_painting} label="Line painting" variant="outlined" />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Traffic_lights_sensor_pads" value={this.state.Cols.Traffic_lights_sensor_pads} label="Traffic lights sensor pads" variant="outlined" />
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item xs={8}>
                          <Card className={classes.root}>
                            <CardContent>
                              <Typography className={classes.title} gutterBottom>
                                TMP DETAILS
                                </Typography>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Speed_limit" value={this.state.Cols.Speed_limit} label="Speed limit(km/h)" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="three_minute_count_Time_of_day" value={this.state.Cols.three_minute_count_Time_of_day} label="3 minute count Time of day?" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Road_width" value={this.state.Cols.Road_width} label="Road width(m)" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Road_A" value={this.state.Cols.Road_A} label="Road A" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Works_width" value={this.state.Cols.Works_width} label="Works width(m)" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Road_B" value={this.state.Cols.Road_B} label="Road B" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Side_Zone" value={this.state.Cols.Side_Zone} label="Side Zone(m)" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Road_C" value={this.state.Cols.Road_C} label="Road C" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Unobstructed_road_width" value={this.state.Cols.Unobstructed_road_width} label="Unobstructed road width (m)" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Road_D" value={this.state.Cols.Road_D} label="Road D" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Roadtype" value={this.state.Roadtype} label="Road type (Single/Dual/one way or two way)" variant="outlined" /> */}
                                  <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Road type (Single/Dual/one way or two way)</InputLabel>
                                    <Select name="Road_type" labelId="selectlabel" id="" value={this.state.Cols.Road_type} onChange={this.inputChange} label="Road type (Single/Dual/one way or two way)" >
                                      <MenuItem value={1}>Single</MenuItem>
                                      <MenuItem value={2}>Dual</MenuItem>
                                      <MenuItem value={3}>One Way</MenuItem>
                                      <MenuItem value={4}>Two Way</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                  {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Anyroadswithhigherspeedlimitwithin100m" value={this.state.Anyroadswithhigherspeedlimitwithin100m} label="Any roads with higher speed limit within 100m?" variant="outlined" /> */}
                                  <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Any roads with higher speed limit within 100m ?</InputLabel>
                                    <Select label="Any roads with higher speed limit within 100m ?" name="roads_with_higher_speed_limit_within_100m" labelId="selectlabel" id="" value={this.state.Cols.roads_with_higher_speed_limit_within_100m} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                  {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Cyclelanespresent" value={this.state.Cyclelanespresent} label="Cycle lanes present?" variant="outlined" /> */}
                                  <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Cycle lanes present ?</InputLabel>
                                    <Select label="Cycle lanes present ?" name="Cycle_lanes_present" labelId="selectlabel" id="" value={this.state.Cols.Cycle_lanes_present} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                  {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Pedestriancrossingsinvicinity" value={this.state.Pedestriancrossingsinvicinity} label="Pedestrian crossings in vicinity" variant="outlined" /> */}
                                  <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Pedestrian crossings in vicinity</InputLabel>
                                    <Select label="Pedestrian crossings in vicinity" name="Pedestrian_crossings_vicinity" labelId="selectlabel" id="" value={this.state.Cols.Pedestrian_crossings_vicinity} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Parking_restrictions" value={this.state.Cols.Parking_restrictions} label="Parking bays affected? Parking restrictions" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Busstopsinvicinity" value={this.state.Busstopsinvicinity} label="Bus stops in vicinity" variant="outlined" /> */}
                                  <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Bus stops in vicinity</InputLabel>
                                    <Select label="Bus stops in vicinity" name="Bus_stops_vicinity" labelId="selectlabel" id="" value={this.state.Cols.Bus_stops_vicinity} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item xs={12}>
                          <Card className={classes.root} variant="outlined">
                            <CardContent>
                              <Typography className={classes.title} gutterBottom>
                                PRE-EXISTING CONDITIONS
                                </Typography>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="main_location_confirmed_on_site" value={this.state.Cols.main_location_confirmed_on_site} label="Main location confirmed on site?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Main location confirmed on site?</InputLabel>
                                    <Select label="Main location confirmed on site ?" name="main_location_confirmed_on_site" labelId="selectlabel" id="" value={this.state.Cols.main_location_confirmed_on_site} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Customer_contacted_or_present" value={this.state.Cols.Customer_contacted_or_present} label="Was Customer contacted / present?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Was Customer contacted / present ?</InputLabel>
                                    <Select label="Was Customer contacted / present ?" name="Customer_contacted_or_present" labelId="selectlabel" id="" value={this.state.Cols.Customer_contacted_or_present} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Is_SWI_required" value={this.state.Cols.Is_SWI_required} label="Is SWI required?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Is SWI required ?</InputLabel>
                                    <Select label="Is SWI required ?" name="Is_SWI_required" labelId="selectlabel" id="" value={this.state.Cols.Is_SWI_required} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="meter_location_agreed" value={this.state.Cols.meter_location_agreed} label="Was meter location agreed?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Was meter location agreed ?</InputLabel>
                                    <Select label="Was meter location agreed ?" name="meter_location_agreed" labelId="selectlabel" id="" value={this.state.Cols.meter_location_agreed} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Road_quality_or_demage" value={this.state.Cols.Road_quality_or_demage} label="Road quality, any pre existing damages? (take photos)" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Indication_of_underground_structures" value={this.state.Cols.Indication_of_underground_structures} label="Indication of underground structures?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Indication of underground structures ?</InputLabel>
                                    <Select label="Indication of underground structures ?" name="Indication_of_underground_structures" labelId="selectlabel" id="" value={this.state.Cols.Indication_of_underground_structures} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Any_TMP_restrictions" value={this.state.Cols.Any_TMP_restrictions} label="Any TMP restrictions" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Any TMP restrictions</InputLabel>
                                    <Select label="Any TMP restrictions" name="Any_TMP_restrictions" labelId="selectlabel" id="" value={this.state.Cols.Any_TMP_restrictions} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Any_third_party_works_vicinity" value={this.state.Cols.Any_third_party_works_vicinity} label="Any third party works in vicinity" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Any third party works in vicinity</InputLabel>
                                    <Select label="Any third party works in vicinity" name="Any_third_party_works_vicinity" labelId="selectlabel" id="" value={this.state.Cols.Any_third_party_works_vicinity} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Stop_or_Go_board_required" value={this.state.Cols.Stop_or_Go_board_required} label="Stop / Go board required?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Stop / Go board required ?</InputLabel>
                                    <Select label="Stop / Go board required ?" name="Stop_or_Go_board_required" labelId="selectlabel" id="" value={this.state.Cols.Stop_or_Go_board_required} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Any_public_buildings_not_identified_on_maps" value={this.state.Cols.Any_public_buildings_not_identified_on_maps} label="Any public buildings not identified on maps" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Any public buildings not identified on maps</InputLabel>
                                    <Select label="Any public buildings not identified on maps" name="Any_public_buildings_not_identified_on_maps" labelId="selectlabel" id="" value={this.state.Cols.Any_public_buildings_not_identified_on_maps} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Adequate_access_or_room_works" value={this.state.Cols.Adequate_access_or_room_works} label="Adequate access / room for works" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Adequate access / room for works</InputLabel>
                                    <Select label="Adequate access / room for works" name="Adequate_access_or_room_works" labelId="selectlabel" id="" value={this.state.Cols.Adequate_access_or_room_works} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Walls_fences_boundaires_affected" value={this.state.Cols.Walls_fences_boundaires_affected} label="Walls / fences / boundaires affected?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Walls / fences / boundaires affected ?</InputLabel>
                                    <Select label="Walls / fences / boundaires affected ?" name="Walls_fences_boundaires_affected" labelId="selectlabel" id="" value={this.state.Cols.Walls_fences_boundaires_affected} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Type_of_machine_required" value={this.state.Cols.Type_of_machine_required} label="Type of machine required" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Restricted_access" value={this.state.Cols.Restricted_access} label="Restricted access" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Restricted access</InputLabel>
                                    <Select label="Restricted access" name="Restricted_access" labelId="selectlabel" id="" value={this.state.Cols.Restricted_access} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Overhead_lines" value={this.state.Cols.Overhead_lines} label="Overhead lines (type, approximate height)" variant="outlined" />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Photos_taken" value={this.state.Cols.Photos_taken} label="Photos taken?" variant="outlined" />
                                  {/* <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                                    <InputLabel id="selectlabel">Photos taken ?</InputLabel>
                                    <Select label="Photos taken ?" name="Photos_taken" labelId="selectlabel" id="" value={this.state.Cols.Photos_taken} onChange={this.inputChange} >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={2}>No</MenuItem>
                                    </Select>
                                  </FormControl> */}
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Card className={classes.root} variant="outlined">
                    <CardContent>
                      <Typography className={classes.title} gutterBottom>
                        Section D - Licence details
                            </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={3}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker variant="inline" label="Application date" format="dd/MM/yyyy" name="Application_date" value={this.state.Cols.Application_date} className={classes.dateField} style={{ width: "100%" }} onChange={handleApplication_dateChange} KeyboardButtonProps={{ 'aria-label': 'Application date' }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={3}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Licence_reference_no" value={this.state.Cols.Licence_reference_no} label="Licence reference no" variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                          {
                            // (this.state.Cols.Restricted_hours === 11) ?
                            //   <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Restricted_hours" value={this.state.Cols.Restricted_hours === 11 ? "" : this.state.Cols.Restricted_hours} label="Restricted hours" variant="outlined" />
                            //   :
                            <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                              <InputLabel id="selectlabel">Restricted hours</InputLabel>
                              <Select label="Restricted hours" name="Restricted_hours" labelId="selectlabel" id="" value={this.state.Cols.Restricted_hours} onChange={this.inputChange} >
                                <MenuItem value={1}>1.Normal hours 8.00am – 5.00pm</MenuItem>
                                <MenuItem value={2}>2.Restricted hours 10.00am – 4.00pm</MenuItem>
                                <MenuItem value={3}>3.Out of hours Mon - Fri 8.00pm – 11.00pm</MenuItem>
                                <MenuItem value={4}>4.Out of hours Mon – Wed 7.30pm – 11.00pm</MenuItem>
                                <MenuItem value={5}>5.Out of hours 7.00pm – 7.00am</MenuItem>
                                <MenuItem value={6}>6.Weekend Sat – Sun 9.00am – 5.00pm</MenuItem>
                                <MenuItem value={7}>7.Weekend Sun 9.00am – 5.00pm</MenuItem>
                                <MenuItem value={8}>8.Weekend Sat 9.00am – 12.00am</MenuItem>
                                <MenuItem value={9}>9.Weekend Sat 7.30pm – 11.00pm</MenuItem>
                                <MenuItem value={10}>10.Outside of normal working hours</MenuItem>
                                <MenuItem value={11}>11.Other</MenuItem>
                              </Select>
                            </FormControl>
                          }
                        </Grid>
                        <Grid item xs={3}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="License_Type" value={this.state.Cols.License_Type} label="License type" variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker label="Licence received date" format="dd/MM/yyyy" name="Licence_received_date" value={this.state.Cols.Licence_received_date} className={classes.dateField} style={{ width: "100%" }} onChange={handleLicence_received_dateChange} KeyboardButtonProps={{ 'aria-label': 'Licence received date' }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={3}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Special_licence_conditions" value={this.state.Cols.Special_licence_conditions} label="Special licence conditions ?" variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                          {/* <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="IsSWIrequiredforlicenceconditions" value={this.state.IsSWIrequiredforlicenceconditions} label="Is SWI required for licence conditions?" variant="outlined" /> */}
                          <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                            <InputLabel id="selectlabel">Is SWI required for licence conditions?</InputLabel>
                            <Select label="Is SWI required for licence conditions?" name="Is_SWI_required_for_licence_conditions" labelId="selectlabel" id="" value={this.state.Cols.Is_SWI_required_for_licence_conditions} onChange={this.inputChange} >
                              <MenuItem value={1}>Yes</MenuItem>
                              <MenuItem value={2}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="LA_Contact_Name" value={this.state.Cols.LA_Contact_Name} label="LA Contact Name" variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker label="Valid from" format="dd/MM/yyyy" name="Valid_from" value={this.state.Cols.Valid_from} className={classes.dateField} style={{ width: "100%" }} onChange={handleValid_fromChange} KeyboardButtonProps={{ 'aria-label': 'Valid from' }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={3}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker label="Valid to" format="dd/MM/yyyy" name="Valid_to" value={this.state.Cols.Valid_to} className={classes.dateField} style={{ width: "100%" }} onChange={handleValid_to} KeyboardButtonProps={{ 'aria-label': 'Valid to' }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={3}>
                          <TextField onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Was_TMP_designed" value={this.state.Cols.Was_TMP_designed} label="Was TMP designed (date / generic)" variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField type="number" onChange={this.inputChange} className={classes.textField} size="small" style={{ width: "100%" }} name="LA_contact_phone_number" value={this.state.Cols.LA_contact_phone_number} label="LA contact phone number" variant="outlined" />
                        </Grid>
                      </Grid >
                    </CardContent >
                  </Card >
                </Grid >
              </Grid >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Card className={classes.root} variant="outlined">
                    <CardContent>
                      <Typography className={classes.title} gutterBottom>
                        Section E - Construction
                        </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={3}>
                          <TextField onChange={this.handleDialogChange} InputProps={{ readOnly: true }} className={classes.textField} size="small" style={{ width: "100%" }} name="Agent_Name" value={this.state.AgentName} label="Agent Name" variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField type="number" onChange={this.handleDialogChange} className={classes.textField} size="small" style={{ width: "100%" }} name="Number" value={this.state.planningData.Number} label="Number" placeholder="What do you want here? Phone number? Employee number?" variant="outlined" />
                        </Grid>
                        <Grid item xs={3}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker className={classes.dateField} name="Proposed_connection_date" label="Proposed connection date" format="dd/MM/yyyy" value={this.state.planningData.Proposed_connection_date} onChange={handleProposedConnectionDate} fullWidth KeyboardButtonProps={{ 'aria-label': 'Change date', }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={3}>
                          {/* <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <KeyboardDatePicker className={classes.dateField} fullWidth name="Permanent_reinstatement_date" label="Permanent reinstatement date(s)" format="dd/MM/yyyy" value={this.state.planningData.Permanent_reinstatement_date} onChange={handlePermanentReinstatementDate} KeyboardButtonProps={{ 'aria-label': 'Change date', }} />
                          </MuiPickersUtilsProvider> */}
                          <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                            <InputLabel id="selectlabel">Confirmed Site Ready?</InputLabel>
                            <Select label="Confirmed Site Ready?" name="Confirmed_Site_Ready" labelId="selectlabel" id="" value={this.state.planningData.Confirmed_Site_Ready} onChange={this.handleDialogChange} >
                              <MenuItem value={1}>Yes</MenuItem>
                              <MenuItem value={2}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                          <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                            <InputLabel id="label">Status</InputLabel>
                            <Select labelId="label" name="status" value={this.state.planningData.status} onChange={this.handleDialogChange} label="Status" style={{ marginBottom: "8px" }} >
                              <MenuItem value={0}>Select Status</MenuItem>
                              <MenuItem value={1}>Cancelled</MenuItem>
                              <MenuItem value={2}>On Hold</MenuItem>
                              <MenuItem value={3}>In Progress</MenuItem>
                              <MenuItem value={4}>Completed</MenuItem>
                            </Select>
                          </FormControl>
                          <TextField onChange={this.handleDialogChange} className={classes.textField} size="small" style={{ width: "100%", marginBottom: "8px" }}
                            disabled={(this.state.planningData.status === 4) ? false : true}
                            type="number" value={this.state.planningData.opening_excavated} name="opening_excavated" label="No of openings excavated (#)" variant="outlined" />
                          {/* <FormControl size="small" variant="outlined" className={classes.textField} fullWidth>
                            <InputLabel id="label">Reinstating Agent</InputLabel>
                            <Select labelId="label" name="reinstating_agent" value={this.state.planningData.reinstating_agent} onChange={this.handleDialogChange} label="Reinstating Agent">
                              <MenuItem value={1}>User 1</MenuItem>
                              <MenuItem value={2}>User 2</MenuItem>
                              <MenuItem value={3}>User 3</MenuItem>
                              <MenuItem value={4}>User 4</MenuItem>
                            </Select>
                          </FormControl> */}
                        </Grid>
                        <Grid item xs={8}>
                          {
                            (this.state.planningData.status !== 0 && !this.state.planningData.reason) ?
                              <TextField error helperText="Reason is mandatory." onChange={this.handleDialogChange} className={classes.textField} size="small" style={{ width: "100%" }} value={this.state.planningData.reason} name="reason" label="Reasons" multiline rows={4} variant="outlined" />
                              :
                              <TextField onChange={this.handleDialogChange} className={classes.textField} size="small" style={{ width: "100%" }} value={this.state.planningData.reason} name="reason" label="Reasons" multiline rows={4} variant="outlined" />
                          }
                        </Grid>
                        <Grid item xs={4}>
                          <FormControl variant="outlined" fullWidth size="small" className={classes.textField}>
                            <InputLabel id="selectlabel">Reinstating Agent</InputLabel>
                            <Select labelId="label" name="reinstating_agent" value={this.state.planningData.reinstating_agent} onChange={this.handleDialogChange} label="Cell">
                              {this.state.reinstatingAgents.map((cell) => (
                                <MenuItem key={cell.name} value={cell.id}>
                                  {cell.name}
                                </MenuItem>
                              ))}
                            </Select>
                            {/* <Select label="Reinstating Agent" name="reinstating_agent" labelId="selectlabel" id="" value={this.state.planningData.reinstating_agent} onChange={this.handleDialogChange} style={{ marginBottom: "8px" }} >
                              <MenuItem value={1}>User 1</MenuItem>
                              <MenuItem value={2}>User 2</MenuItem>
                              <MenuItem value={3}>User 3</MenuItem>
                              <MenuItem value={4}>User 4</MenuItem>
                            </Select> */}
                          </FormControl>
                        </Grid>
                        <Grid item xs={2}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker className={classes.dateField} style={{ width: "100%" }} onChange={handleactualstartdate} name="actual_start_date" label="Actual Start (Time & Date)" format="dd/MM/yyyy hh:mm:ss" value={this.state.planningData.actual_start_date} KeyboardButtonProps={{ 'aria-label': 'Change date', }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={2}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker className={classes.dateField} style={{ width: "100%" }} onChange={handleactualfinishdate} name="actual_finish_date" label="Actual Finish (Time & Date)" format="dd/MM/yyyy hh:mm:ss" value={this.state.planningData.actual_finish_date} KeyboardButtonProps={{ 'aria-label': 'Change date', }} />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <br /><br /><br /><br />
                        <Grid item xs={12}>
                          <MaterialTable
                            title="Surface Category, width & length"
                            columns={[
                              { title: 'Surface Category', field: 'surface_category', type: 'numeric', lookup: this.state.surfacecategoryfilter },
                              { title: 'Public/Private', field: 'public_or_private', type: 'numeric', lookup: Headers.lookupPrivatePublic },
                              { title: 'Opening Length', field: 'length', type: 'numeric' },
                              { title: 'Opening Width', field: 'width', type: 'numeric' },
                              { title: 'Reinstating Crew', field: 'reinstating_crew', lookup: this.state.reinstatingCrews },
                              { title: 'Start Time', field: 'start_time', type: "datetime" },
                              { title: 'Finish Time', field: 'finish_time', type: "datetime" },
                              { title: 'Reinstated Length', field: 'reinstated_length', type: 'numeric' },
                              { title: 'Reinstated Width', field: 'reinstated_width', type: 'numeric' },
                              { title: 'Reason for Extra Over Reinstatement /  Other Comments', field: 'reason_reinstatement' },
                              { title: 'Full Bay / Full Road Reinstatement', field: 'fullbay_fullroad', type: 'numeric', lookup: Headers.lookupFullBay_FullRoadReinstatement },
                              { title: 'Work_Order', field: 'Work_Order', type: 'numeric', hidden: true },
                              { title: 'planning', field: 'planning', type: 'numeric', hidden: true },
                              { title: 'precon', field: 'precon', type: 'numeric', hidden: true },
                              { title: 'sec_e', field: 'sec_e', type: 'numeric', hidden: true }
                            ]}
                            data={this.state.surface_category}
                            editable={{
                              onRowUpdate: (newData, oldData) =>
                                new Promise((resolve) => {
                                  this.updateSurfaceCategoryData(newData, oldData, resolve);
                                }),
                              onRowAdd: (newData) =>
                                new Promise((resolve) => {
                                  this.insertSurfaceCategoryData(newData, resolve);
                                }),
                              onRowDelete: (oldData) =>
                                new Promise((resolve) => {
                                  this.deleteSurfaceCategoryData(oldData, resolve)
                                }),
                            }}
                            // editable={{
                            //   onRowUpdate: (newData, oldData) =>
                            //     new Promise((resolve, reject) => {
                            //       setTimeout(() => {
                            //         const planningData = this.state.planningData;
                            //         const planningData_surface_category = [...planningData.surface_category];
                            //         const index = oldData.tableData.id;
                            //         planningData_surface_category[index] = newData;
                            //         planningData.surface_category = planningData_surface_category;
                            //         this.setState({ planningData: planningData });
                            //         resolve();
                            //       }, 1000)
                            //     }),
                            //   onRowAdd: newData =>
                            //     new Promise((resolve, reject) => {
                            //       setTimeout(() => {
                            //         const planningData = this.state.planningData;
                            //         const planningData_surface_category = [...planningData.surface_category];
                            //         planningData_surface_category.push(newData);
                            //         planningData.surface_category = planningData_surface_category;
                            //         this.setState({ planningData: planningData });
                            //         resolve();
                            //       }, 1000);
                            //     }),
                            //   onRowDelete: oldData =>
                            //     new Promise((resolve, reject) => {
                            //       setTimeout(() => {
                            //         const planningData = this.state.planningData;
                            //         const planningData_surface_category = [...planningData.surface_category];
                            //         const index = oldData.tableData.id;
                            //         planningData_surface_category.splice(index, 1);
                            //         planningData.surface_category = planningData_surface_category;
                            //         this.setState({ planningData: planningData });
                            //         resolve()
                            //       }, 1000)
                            //     }),
                            // }}
                            options={{
                              actionsColumnIndex: -1
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} >
                          {/* <Button className={classes.button} variant="contained" color="primary" onClick={this.handleOpen}>Upload File</Button> */}
                          <MaterialTable
                            title="Files"
                            columns={[
                              { title: 'Name', field: 'name' },
                              // { title: 'Description', field: 'description' },
                            ]}
                            actions={[
                              {
                                icon: CloudUploadIcon,
                                tooltip: 'Upload File',
                                isFreeAction: true,
                                onClick: (event) => { this.setState({ OpenDialog: true }); }
                              },
                              {
                                icon: 'launch',
                                tooltip: 'Open in New Tab',
                                onClick: (event, rowData) => { this.handleView(rowData); }
                              },
                              {
                                icon: CloudDownloadIcon,
                                tooltip: 'Download',
                                onClick: (event, rowData) => { this.handleDownload(rowData); }
                              },
                              {
                                icon: 'delete',
                                tooltip: 'Delete',
                                onClick: (event, rowData) => {
                                  this.setState({ OpenDeleteDialog: true, DeleteRowData: rowData });
                                }
                              }
                            ]}
                            isLoading={this.state.isLoadTable}
                            data={this.state.Cols.files}
                            options={{
                              actionsColumnIndex: -1
                            }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <DropzoneDialog
                open={this.state.OpenDialog}
                maxFileSize={20000000}
                onSave={this.handleSave.bind(this)}
                filesLimit={5}
                acceptedFiles={
                  [
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/pdf',
                    'image/gif', 'image/vnd.microsoft.icon', 'image/jpeg', 'image/png', 'image/bmp'
                  ]}
                showPreviews={true}
                onClose={this.handleClose.bind(this)} />

              <Dialog
                open={this.state.OpenDeleteDialog}
                onClose={this.handleCloseDeleteDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Delete File ?"}</DialogTitle>
                <DialogContent>
                  <DialogContentText component="div">
                    Are you sure ! You want to delete this ?
                   </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleCloseDeleteDialog} color="primary">
                    Disagree
                  </Button>
                  <Button onClick={this.handleDeleteFile} color="primary" autoFocus>
                    Agree
                  </Button>
                </DialogActions>
              </Dialog>
            </div >
          )
        }
      </div >
    );
  }
}
export default withStyles(classes)(withSnackbar(PreConstructionForm));